const preferences = {
  appLanguage: {
    helpText: 'Actualiza el idioma de la aplicación cuando la localización está disponible.',
    label: 'Idioma de la aplicación',
    options: {
      en: 'Inglés',
      enUS: 'Inglés (Estados Unidos)',
      enGB: 'Inglés (Reino Unido)',
      enCA: 'Inglés (Canadá)',
      es: 'Español',
      esMX: 'Español (México)',
      fr: 'Francés',
      frCA: 'Francés (Canadá)',
    },
    useDeviceLanguage: 'Usar el idioma del dispositivo',
  },
  assistantReplies: {
    helpText: 'Se aplica solo a las nuevas respuestas del asistente.',
    label: 'Respuestas del asistente',
    matchAppLanguage: 'Usar el idioma de la aplicación',
  },
  errors: {
    loadFailed: 'No se pudieron cargar las preferencias.',
    saveFailed: 'No se pudo guardar esta configuración.',
  },
  savedPrompts: {
    actions: {
      delete: 'Eliminar indicación',
      edit: 'Editar indicación',
      moveDown: 'Mover indicación hacia abajo',
      moveUp: 'Mover indicación hacia arriba',
      new: 'Nueva indicación',
      send: 'Enviar indicación',
    },
    ariaLabel: 'Indicaciones guardadas',
    deleteDialog: {
      confirmation: '¿Eliminar <strong>{{title}}</strong>? Esta acción no se puede deshacer.',
      deleting: 'Eliminando...',
      title: '¿Eliminar indicación guardada?',
    },
    editor: {
      cancel: 'Cancelar',
      discardChanges: 'Descartar cambios',
      discardChangesMessage: 'Se perderán los cambios no guardados en la indicación.',
      discardChangesTitle: '¿Descartar cambios?',
      editTitle: 'Editar indicación guardada',
      keepEditing: 'Seguir editando',
      newTitle: 'Nueva indicación guardada',
      save: 'Guardar indicación',
      saving: 'Guardando...',
    },
    empty: 'Todavía no hay indicaciones guardadas',
    errors: {
      createFailed: 'No se pudo crear esta indicación.',
      deleteFailed: 'No se pudo eliminar esta indicación.',
      loadFailed: 'No se pudieron cargar las indicaciones guardadas.',
      reorderFailed: 'No se pudo reordenar esta indicación.',
      saveFailed: 'No se pudo guardar esta indicación.',
      updateFailed: 'No se pudo actualizar esta indicación.',
    },
    form: {
      characterCount_one: '{{count}} / {{maximum}} carácter',
      characterCount_other: '{{count}} / {{maximum}} caracteres',
      promptTextLabel: 'Indicación',
      titleLabel: 'Título',
    },
    fromResponse: {
      action: 'Guardar como indicación',
      error: 'No se pudo preparar una indicación guardada. Inténtelo de nuevo.',
      preparing: 'Preparando indicación...',
    },
    loading: 'Cargando indicaciones guardadas',
    validation: {
      promptTextMax: 'El texto de la indicación debe tener {{maximum}} caracteres o menos.',
      promptTextRequired: 'El texto de la indicación es obligatorio.',
      titleMax: 'El título debe tener {{maximum}} caracteres o menos.',
      titleRequired: 'Es obligatorio indicar un título.',
    },
  },
  settings: {
    ariaLabel: 'Configuración de usuario',
    loading: 'Cargando configuración',
    saving: 'Guardando configuración',
  },
} as const;

export default preferences;